import { FC } from "react";
import { BreakableName, FileFullName } from "../../../helper/general/methods";

interface FileIconProps {
  fileName: string;
  fileType: string;
  isForged: boolean;
  isSelected: boolean;
  onClick: () => void;
}

// PDFs get their own glyph so drawing sets stand out from other files
export const FileIconSource = (fileType: string): string => {
  if (fileType === "ifc") {
    return "assets/icons/model.png";
  }
  if (fileType === "pdf") {
    return "assets/icons/pdf.png";
  }
  return "assets/icons/file.png";
};

const FileIcon: FC<FileIconProps> = ({
  fileName,
  fileType,
  isForged,
  isSelected,
  onClick,
}) => {
  const iconSrc = FileIconSource(fileType);
  const itemClass = isSelected ? "selectedItem" : "unSelectedItem";

  return (
    <div className={itemClass} onClick={onClick}>
      <div className="itemGraphic">
        <img
          className="icon-big"
          src={iconSrc}
          draggable="false"
          alt={fileName}
        />
        {isForged ? (
          // Marks the file as mirrored from a connected platform rather than
          // uploaded here, which is what explains why deleting it brings it
          // back on the forge's next run.
          <img
            className="forgedMarker"
            src="assets/icons/forge.png"
            draggable="false"
            alt=""
            title="Kept in step by a forge. Changes made here are replaced from the source."
          />
        ) : (
          <></>
        )}
      </div>
      <span title={FileFullName(fileName, fileType)}>
        {BreakableName(fileName)}
      </span>
    </div>
  );
};

export default FileIcon;
